import React, {Component} from 'react'
import update from 'react-addons-update';
import LinkWithTooltip from '../../tooltip';

class Checkbox extends Component {

  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      value: 0
    };
  }

  componentDidMount(){
    if (this.props.input.value == '1') {
      this.setState({
        checked: true,
        value: 1
      })
    } else {
      this.setState({
        checked: false,
        value: 0
      })
    }
  }

  componentWillReceiveProps(nextProps){

    if ( nextProps.input.value != 0 ) {
      this.setState({
        checked: true,
        value: nextProps.input.value
      });
    } else {
      this.setState({
        checked: false,
        value: nextProps.input.value
      });
    }
  }

  handChangeClick(e){
    e.preventDefault();

    if (this.state.value == '0') {
      var value = 1;
    } else {
      var value = 0;
    }

    this.setState({
      checked: !this.state.checked,
      value: value
    })
  }

  componentDidUpdate(){
    const { input: { onChange } } = this.props
    onChange(this.state.value);
  }

  render(){
    const { input, params } = this.props

    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <div
          className="sp-pagebuilder-sp-checkbox"
          onClick={
            this.handChangeClick.bind(this)
          }
        >
          <input id="field_use_link" className="sp-pagebuilder-addon-input" type="checkbox" checked={this.state.checked} value={this.state.value} />
          <label htmlFor="field_use_link">
            <span>
              <span></span>
              <strong className="sp-pagebuilder-sp-checkbox-1">YES</strong>
              <strong className="sp-pagebuilder-sp-checkbox-2">NO</strong>
            </span>
          </label>
        </div>
      </div>
    )
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Checkbox.js